import {
  useFetchMySuspensions,
  useMySuspensions,
  useMySuspensionsByProgramInstance,
} from './useMySuspensions'

export { useInvalidateMySuspensions } from './useMySuspensions'
export {
  canRequalify,
  formatShiftTime,
  getEarliestShiftSuspension,
  getNextShiftPollInterval,
  getSuspensionCopyVariant,
  isDeadlinePassed,
  isPartTimeShiftRow,
} from './suspensionShift'
export type { ShiftSuspension, SuspensionCopyVariant } from './suspensionShift'
export type { MySuspension, SuspensionNotice } from './useMySuspensions'

export const suspensions = {
  mine: useMySuspensions,
  mineByProgramInstance: useMySuspensionsByProgramInstance,
  fetchMine: useFetchMySuspensions,
}
